import { Icon } from '@latitude/icons';
import { cn } from '@latitude/token-utils';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import type { ComponentRef, PropsWithChildren, Ref } from 'react';
import { triggerVariants } from 'variants/trigger-variants';

import { useAccordionContext } from '../AccordionContext';

export const AccordionBaseTrigger = ({
  className,
  children,
  ref,
  ...props
}: PropsWithChildren<{ className?: string }> & {
  ref?: Ref<ComponentRef<typeof AccordionPrimitive.Trigger>>;
}) => {
  const context = useAccordionContext();
  const accordionHeaderClasses = cn({
    'hover:bg-color-comp-accordion-filled-container-hover':
      context?.fill === 'filled' && !context.disabled,
    'hover:bg-color-comp-accordion-outline-container-hover':
      context?.fill === 'outlined' && !context.disabled,
    flex: true,
    'transition-colors': true,
    'duration-300': true,
  });

  return (
    <AccordionPrimitive.Header className={accordionHeaderClasses}>
      <AccordionPrimitive.Trigger
        ref={ref}
        className={cn(triggerVariants({ size: context?.size }), className)}
        data-testid="accordion-trigger"
        {...props}
      >
        {children}
        <Icon
          name="chevron-down"
          className="size-6 shrink-0 transition-transform duration-200"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
};

AccordionBaseTrigger.displayName = AccordionPrimitive.Trigger.displayName;
